<template>
    <div id="tm-sidebar-left" class="tm-sidebar-left scroller">                
        <ul class="uk-tab uk-flex-center" uk-switcher="animation: uk-animation-fade">
            <li><a href="#" style="padding-left: 5px; padding-right: 5px;" uk-tooltip="title: Pre-designed Templates; pos: bottom; delay: 500;">Type</a></li>
            <li><a href="#" style="padding-left: 5px; padding-right: 5px;">My Mains</a></li>
        </ul>
        <ul class="uk-switcher uk-grid-small uk-child-width-1-1 uk-child-width-1-1@s uk-text-center uk-padding-none" uk-grid>
            <div class="uk-margin-remove uk-padding-remove">
                <!-- WATERMARK COMPONENT -->
                <li> 
                    <div class="uk-text-small uk-text-muted uk-text-left">
                        Watermark
                    </div>
                    <a>
                        <!-- CARD -->
                        <div class="uk-card checkered uk-box-shadow-hover-large uk-card-default uk-card-body uk-transition-toggle uk-padding-remove">
                        <img src="https://img0.etsystatic.com/189/0/5422773/il_570xN.1219244336_cxz4.jpg">  
                        </div>
                    </a>
                </li>
            </div>
            <div>
                <form>
                    <fieldset class="uk-fieldset uk-text-left">
                        <div class="uk-margin">
                            <label class="uk-form-label uk-text-muted uk-text-bold" for="form-stacked-text">Main Logo</label>
                            <div class="uk-form-controls">
                                <a class="uk-button uk-button-default uk-button-small uk-width-1-1" style="border-radius: 4px;" uk-tooltip="title: This logo will be used in some templates for you to choose from.; pos: bottom; delay: 500;">upload</a>
                            </div>                            
                        </div>
                        <div class="uk-margin">
                            <label class="uk-form-label uk-text-muted uk-text-bold" for="form-stacked-text">Main Name / Signature</label>
                            <div class="uk-form-controls">
                                <input class="uk-input uk-form-small" id="form-stacked-text" type="text" placeholder="Some text...">
                            </div>                           
                        </div>



                    </fieldset>
                </form>                                                  
            </div>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'sidebar-design'
    }
</script>

<style scoped> 
.uk-active {
    margin: none;
    padding: none;
}

  .tm-sidebar-left .uk-dropdown {
      outline: 2px solid #A9A9A9;
      box-shadow: 0 10px 20px rgba(0,0,0,.4);
      min-width: 60px !important;
  }

  .uk-card {
      min-height: 100px;
      outline: 2px solid #A9A9A9;
  }

  .uk-card-active {
      outline: 2px solid #28a5f5;
  }

  .uk-placeholder {
      border: none;
  }

  .uk-panel .uk-padding-small {
      padding: 8px 10px 8px 10px;
  }

</style>